import {
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

// SESSION-admin-ptg-003 — `.ar-tag` pill. Generic = neutral; Client = coral.
// `accountName` only used when type === 'client'.
@Component({
    selector: 'app-ar-tag',
    templateUrl: './ar-tag.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ArTagComponent {
    @Input() type: 'generic' | 'client' = 'generic';
    @Input() accountName: string | null = null;
}
